import React from "react";
import puzzleIcon from "../../assets/img/becomeanagent/puzzle.svg";
import "./AgentCard.css";

const openInNewTab = (url) => {
  window.open(url, "_blank").focus();
};
const AgentCard = ({ responsiveStatus, state, bgColor, url }) => (
  <div className={`flex-1  text-center ${bgColor}`}>
    <img
      src={puzzleIcon}
      alt="Puzzle Icon"
      className="mx-auto mb-2 "
      style={{ width: "20%", height: "20%" }}
    />
    <h2 className="text-xl mb-4">Agent for {state}</h2>
    <p
      className={`${
        responsiveStatus
          ? "text-gray-700M mb-6 max-w-md"
          : "text-gray-700 mb-6 max-w-md mx-auto"
      }`}
      style={{ padding: "0 30px", marginBottom: "2em" }}
    >
      Not a customer yet? No problem! You can easily file a claim through our
      platform. Provide your details and relevant information, and our team will
      assist you promptly. Experience hassle-free support, anytime.
    </p>
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
    >
      Get Started
    </a>
  </div>
);

const AgentGrid = ({ responsiveStatus }) => {
  return (
    // <div className="min-h-screen flex flex-col md:flex-row">
    <div style={{ flex: 1, maxWidth: "1000px" }}>
      <p
        style={{
          color: "#515050",
          fontSize: "18px",
          // lineHeight:
          //   responsiveStatus === "isDesktop"
          //     ? ""
          //     : responsiveStatus === "isTablet" ||
          //       responsiveStatus === "isTabletLandscape"
          //     ? ""
          //     : "",
          marginTop: "1em",
          paddingBottom: "0px",
        }}
      >
        Partner with us and take your agency to the next level. Gain access to
        competitive insurance products, lucrative commissions, personalized
        support, and the tools you need to succeed. Start your appointment
        today!{" "}
      </p>
      <p
        style={{
          color: "#515050",
          fontSize: "18px",
          // lineHeight:
          //   responsiveStatus === "isDesktop"
          //     ? "0.6"
          //     : responsiveStatus === "isTablet" ||
          //       responsiveStatus === "isTabletLandscape"
          //     ? "0.6"
          //     : "1.2",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        To get started, select your state below.
      </p>

      <div
        style={{
          position: "relative",
          width:
            responsiveStatus === "isDesktop"
              ? "70%"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "70%"
              : "100%",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: `${
              responsiveStatus === "isDesktop"
                ? "block"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "block"
                : "flex"
            }`,
            alignItems: "center",
            margin: "0 auto",
            width: "fit-content",
            minWidth: "300px",
          }}
        >
          <label
            htmlFor="state-select"
            style={{ fontSize: "12px", fontWeight: "bold", display: "none" }}
          >
            Select State
          </label>
          <br />
          <select
            id="state-select"
            name="state-select"
            aria-label="Select your state"
            onChange={(e) => {
              // redirect on selection (if desired)
              const selectedUrl = e.target.value;
              if (selectedUrl) {
                window.location.href = selectedUrl;
              }
            }}
            style={{
              flex: 1,
              padding: "8px 10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              appearance: "auto",
              backgroundColor: "white",
              width: "100%",
              height: "35px",
              fontSize: "12px",
              maxWidth: "275px",
              marginLeft: "1em",
            }}
          >
            <option value="" disabled selected>
              Select
            </option>
            <option value="https://baa.uaig.net/fl/index.php">Florida</option>
            <option value="https://baa.uaig.net/ga/index.php">Georgia</option>
            <option value="https://baa.uaig.net/tx/index.php">Texas</option>
          </select>

          {/* <button
            style={{
              marginLeft: "10px",
              backgroundColor: "#007BFF",
              color: "white",
              border: "none",
              borderRadius: "5px",
              padding: "8px 20px",
              cursor: "pointer",
              fontSize: "12px",
            }}
            onClick={() => {
              const selectElement = document.querySelector("select");
              if (selectElement && selectElement.value) {
                openInNewTab(selectElement.value);
              }
            }}
          >
            Get Started
          </button> */}
        </div>
      </div>
    </div>

    // </div>
  );
};

export default AgentGrid;
